module.exports = __webpack_public_path__ + "img/small.737d156a.jpg";